<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="Manage Users" class="card-container"></Header>
      <div  class="col-md-12">
        <div  class="row">
          <export-group  style="margin-left:-12px;" :name="'Users'" :excelUrl="`api/applicationusers/excel`"
            :getData="getExportData"></export-group>

          <div class="col-md-4 offset-md-8">
            <div class="row flex-row-reverse">
              <div class="col-md-8">
                <label for="searchBox">Search:</label>
                <el-input id="searchBox" type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                  @input="search()" v-model="searchText" placeholder="Search all Users..." v-b-popover.hover.top="'Search results appear immediately upon typing.'
                    "></el-input>
                <a style="color: #0e8142; cursor: pointer;" @click="redirectSearch()">Advanced Search</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div    class="row">
        <el-table :data="paginatedUsers.results" :default-sort="{ prop: 'email', order: 'descending' }">
          <el-table-column :min-width="150" align="left" label="Actions" sortable>
            <div slot-scope="scope">
              <span class="hide-if-medium-screensize"></span>
              <router-link :to="'/admin/profiles/' + scope.row.id" class="btn-link btn-primary">
                <i v-if="!isOUSD" class="tim-icons icon-pencil"></i>
                <span v-if="!isOUSD" class="hide-if-small-screensize">Edit</span>
                <span v-else class="hide-if-small-screensize">View</span>
              </router-link>
            </div>
          </el-table-column>

          <el-table-column sortable v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
            :prop="column.prop" :label="column.label"></el-table-column>
          <el-table-column :min-width="140" label="Expiration Date" sortable>
            <div
              :style="{ height: '70px', width: '100%', textAlign: 'center', backgroundColor: backgroundColor(scope.row.expirationDate, !['PENDING', 'REJECTED' ].includes(scope.row.approvalStatusName)) }"
              v-if="parseInt(dateDifference(scope.row.expirationDate))" slot-scope="scope">
              <span class="hide-if-medium-screensize"></span>
              {{ dayjs(scope.row.expirationDate).format('MM/DD/YYYY') }}
            </div>

            <div style="text-align: center;" v-else slot-scope="scope">
              <span class="hide-if-medium-screensize"></span>
              Invalid Date
            </div>
          </el-table-column>
        </el-table>
      </div>

      <div class="row justify-content-end">
        <label for="ResultsPerPageDropdown" class="results-per-page">Results Per Page:</label>
        <el-select id="ResultsPerPageDropdown" v-model="pageCount" @change="getPaginateUsers()" name="PageOptions"
          class="select-primary">
          <el-option v-for="(item, index) in pageCountOptions" :value="item" class="select-primary"
            :key="index"></el-option>
        </el-select>

        <base-pagination v-model="paginatedUsers.currentPage" @input="getPaginateUsers()"
          :perPage="paginatedUsers.pageSize" :pageCount="paginatedUsers.pageCount">
        </base-pagination>
      </div>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn, Select, Option } from "element-ui";
import Treeselect from "@riophae/vue-treeselect";
import { BaseButton, Modal, ImageUpload, BasePagination, BaseSwitch, ExportGroup } from "@/components";
import Header from "@/components/App/Header.vue";
import Util from "@/util/util";
import dayjs from 'dayjs';
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "admin-users-dashboard",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BasePagination,
    BaseButton,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    ImageUpload,
    Header,
    ExportGroup,
  },
  data() {
    return {
      images: {
        regular: null,
      },
      map: {
        "FirstName": "firstName",
        "MiddleName": "middleName",
        "LastName": "lastName",
        "Title": "title",
        "PhoneNumber": "phoneNumber",
        "Organization": "organizationName",
        "Email": "email",
        "ApprovedBy": "approverName",
        "Roles": "roleString",
        "ApprovalStatus": "approvalStatusName",
        "ExpirationDate": "expirationDate",

      },
      tableColumns: [
        {
          prop: "email",
          label: "User Email",
          minWidth: 160,
        },
        {
          prop: "approverName",
          label: "Approved By",
          minWidth: 180,
        },
        {
          prop: "firstName",
          label: "First Name",
          minWidth: 160,
        },
        {
          prop: "lastName",
          label: "Last Name",
          minWidth: 160,
        },
        {
          prop: "roleString",
          label: "Roles",
          minWidth: 160,
        },
        {
          prop: "organizationName",
          label: "Organization",
          minWidth: 180,
        },
        {
          prop: "approvalStatusName",
          label: "Approval Status",
          minWidth: 180,
        },
      ],
      searchTimeOut: null,
      pageCount: 5,
      searchText: "",
      pageCountOptions: [],
      openSearchModal: false,
    };
  },
  async created() {
    this.pageCountOptions = Util.getInitialPaginationInfo().perPageOptions;
    this.$loaderApp.addRequest();

    await this.getAllUsersPaginate({
      pageNumber: this.paginatedUsers.currentPage
        ? this.paginatedUsers.currentPage
        : 1,
      pageCount: this.paginatedUsers.pageSize
        ? this.paginatedUsers.pageSize
        : this.pageCount,
      searchText: this.searchText ? this.searchText : "",
    });
    this.$loaderApp.completeRequest();

  },
  watch: {},
  computed: {
    ...mapGetters({
      users: "users/allUsers",
      user: "adminUsers/user",
      paginatedUsers: "users/paginatedUsers",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      approvalStatuses: "approvalStatus/approvalStatuses",
      isOUSD: "authentication/isOUSD",
    }),
    selectedPageCount() {
      return this.pageCount;
    },
    backgroundColor: function () {
      var vm = this;
      return function (date, isActive = true) {
        if(!isActive) return 'transparent'

        var difference = vm.dateDifference(date);

        if (difference <= 60) return 'rgb(255, 206, 206)';

        else if (difference <= 90) return 'rgb(240,209,78)';

        else return 'transparent';
      };
    }
  },
  methods: {
    ...mapActions({
      getAllUsersPaginate: "users/getAllUsersPaginate",
      getUser: "adminUsers/getUser",
      saveUser: "adminUsers/saveUser",
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getStatuses: "approvalStatus/getApprovalStatuses",
    }),
    dayjs,
    async getPaginateUsers() {
      var paginationInfo = {
        pageNumber: this.paginatedUsers.currentPage
          ? this.paginatedUsers.currentPage
          : 1,
        pageCount: this.pageCount,
        searchText: this.searchText ? this.searchText : "",
      };

      await this.getAllUsersPaginate(paginationInfo);
    },
    search() {
      clearTimeout(this.searchTimeOut);

      var self = this;
      self.searchTimeOut = setTimeout(function () {
        self.paginatedUsers.currentPage = 1;
        self.getPaginateUsers();
      }, 1000);
    },
    async getExportData() {
      return {}
    },
    onImageChange(file) {
      this.images.regular = file;
    },
    getUserdata(id) {
      this.getUser(id);
    },
    cancelAdminUserModalClicked() {
      this.$refs.AdminUserModal.hide();
    },

    openAdvancedSearch() {
      this.$refs.testd.show();
    },

    dateDifference(date) {

      const today = dayjs(new Date());
      const expiry = dayjs(date);
      if (expiry != 'Invalid Date' && today) {
        const days = expiry.diff(today, 'days');
        if (days) {
          return days

        } else {
          return "Invalid Date"
        }
      }
    },

    redirectSearch() {
      this.$router.push("/Admin/users/AdvancedSearch");
    },
  },
};
</script>

<style scoped></style>